import {
    InviteType,
    TABS,
    UserActionType,
    UserRole,
    USER_PROP,
} from 'pages/User/constants'

export const initialCreateState = {
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    role: UserRole.USER,
    groups: [],
}

export const initialBreakDown = {
    members: 0,
    pending_approval: 0,
    super_users: 0,
}

export const getDefaultState = () => ({
    editUser: initialCreateState,
    selectedTab: TABS.MEMBER_TAB,
    createUserDialog: initialCreateState,
    initialBreakDown,
    table: {
        orderBy: {
            col: USER_PROP.FNAME,
            order: 'asc',
        },
        search: '',
        limit: 10,
        offset: 0,
        filters: [],
    },
    inviteType: InviteType.EMAIL,
    inviteLink: '',
    selectedRole: UserRole.USER,
    isEditDialogOpen: false,
    isCreateDialogOpen: false,
    isConfirmationDialogOpen: false,
    members: [],
    total: 0,
    existingGroups: [],
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case UserActionType.SET_USER_DATA:
            return setEditUser(state, action)
        case UserActionType.SET_USERS:
            return setUsersData(state, action)
        case UserActionType.OPEN_DIALOG:
            return openEditDialog(state, action)
        case UserActionType.CLOSE_DIALOG:
            return closeEditDialog(state, action)
        case UserActionType.CLOSE_CREATE_DIALOG:
            return closeCreateDialog(state, action)
        case UserActionType.OPEN_CREATE_DIALOG:
            return openCreateDialog(state, action)
        case UserActionType.SET_INVITE_TYPE:
            return setInviteType(state, action)
        case UserActionType.SET_INVITE_LINK:
            return setInviteLink(state, action)
        case UserActionType.SET_ORDER_BY:
            return setOrderBy(state, action)
        case UserActionType.SET_PAGING_OPT:
            return setPagingOptions(state, action)
        case UserActionType.SET_PAGE_OFFSET:
            return setPageOffset(state, action)
        case UserActionType.SET_FILTER:
            return setFilter(state, action)
        case UserActionType.SET_SEARCH_TEXT:
            return setSearchText(state, action)
        case UserActionType.SET_CONFIRMATION_DIALOG:
            return SetCreateConfirmationDialog(state, action)
        case UserActionType.SET_CREATE_USER:
            return setCreateUserDialog(state, action)
        case UserActionType.SET_BREAK_DOWN:
            return setBreakdown(state, action)
        case UserActionType.SET_TAB:
            return setSelectedTab(state, action)
        case UserActionType.SET_EXISTING_GROUPS:
            return setExistingGroups(state, action)
        default:
            return state
    }
}

const setEditUser = (state, { data }) => {
    return {
        ...state,
        editUser: data,
    }
}

const setUsersData = (state, { members }) => {
    return {
        ...state,
        members: members.rows,
        total: members.total,
    }
}

const closeEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: false,
        editUser: initialCreateState,
    }
}

const openEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: true,
    }
}

const closeCreateDialog = (state) => {
    return {
        ...state,
        inviteType: InviteType.EMAIL,
        inviteLink: '',
        isCreateDialogOpen: false,
        createUserDialog: initialCreateState,
    }
}

const openCreateDialog = (state) => {
    return {
        ...state,
        isCreateDialogOpen: true,
    }
}

const setInviteType = (state, { inviteType }) => {
    return {
        ...state,
        inviteType,
    }
}
function setSelectedTab(state, { selectedTab }) {
    return {
        ...state,
        selectedTab,
    }
}

function setBreakdown(state, { breakDown }) {
    return {
        ...state,
        breakDown,
    }
}

function setCreateUserDialog(state, action) {
    return {
        ...state,
        createUserDialog: action.createUserDialog,
    }
}

function SetCreateConfirmationDialog(state, action) {
    return {
        ...state,
        isConfirmationDialogOpen: action.isOpen,
    }
}

function setSearchText(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            search: action.search,
        },
    }
}

function setFilter(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            filters: action.filters,
        },
    }
}

function setPageOffset(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            offset: action.offset,
        },
    }
}

function setPagingOptions(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            limit: action.paging.limit,
            offset: action.paging.offset,
        },
    }
}

function setOrderBy(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            orderBy: action.orderBy,
        },
    }
}

function setInviteLink(state, action) {
    return {
        ...state,
        inviteLink: action.inviteLink,
    }
}

const setExistingGroups = (state, { data }) => {
    return {
        ...state,
        existingGroups: data.rows,
    }
}
